const ClassSubTitle = ({ href, title, subTitle, textColor, index }) => {
  return (
    <a className="right-item" href={`#${href}`} style={{ color: textColor }}>
      <p
        className={`right-title font-amaticsc-bold`}
      >
        {title}
      </p>
      <p
        className={`right-sub-title font-zenkurenaido`}
      >
        {subTitle}
      </p>
    </a>
  );
};

export default ClassSubTitle;
